import { motion } from 'framer-motion'
import { StyleBidirectionCardWrapper } from './style'
import { StyleImageWrapper } from '../ImageWrapper/style'
import { StyleText, StyleTextWrapperAlternate } from '../Text/style'

interface IBirectionCard {
  imgSrc: string
  title: string
  subtitle: string
  direction?: string
  marginTop?: string
}

const MotionBidirectionCardWrapper = motion(StyleBidirectionCardWrapper)
const MotionImageWrapper = motion(StyleImageWrapper)
const MotionTextWrapperAlternate = motion(StyleTextWrapperAlternate)
const MotionText = motion(StyleText)

const cardVariants = {
  offscreen: {
    opacity: 0,
    y: 50,
  },
  onscreen: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      bounce: 0.4,
      duration: 0.8,
    },
  },
}

const imageVariants = {
  hover: {
    scale: 1.05,
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },
}

const textVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
}

const BiDirectionCard = ({
  imgSrc,
  title,
  subtitle,
  direction,
  marginTop,
}: IBirectionCard) => {
  return (
    <MotionBidirectionCardWrapper
      direction={direction}
      marginTop={marginTop}
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, margin: '0px 0px -100px 0px' }}
      variants={cardVariants}
    >
      <MotionImageWrapper
        direction={direction}
        flex={2}
        whileHover="hover"
        variants={imageVariants}
      >
        <img src={imgSrc} alt="" />
      </MotionImageWrapper>

      <MotionTextWrapperAlternate
        variants={textVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <MotionText
          fontSize="24"
          weight="400"
          fontSizeSm="1"
          variants={itemVariants}
        >
          {title}
        </MotionText>
        <MotionText
          fontSize="16"
          weight="400"
          fontSizeSm="0.6"
          variants={itemVariants}
        >
          {subtitle}
        </MotionText>
      </MotionTextWrapperAlternate>
    </MotionBidirectionCardWrapper>
  )
}

export default BiDirectionCard
